import type { WithActiveBranchId } from '@app/api/shared';

export enum LoyaltyEndpoints {
  PayWithBonuses = 'PayWithBonuses',
  ApplyReturnAsync = 'ApplyReturnAsync',
  GetRecordInfoAsync = 'GetRecordInfoAsync',
}

export type DiscountType = 'Bonus' | 'LoyaltyDiscount' | 'Discount';

export interface LoyaltyModelPayWithBonuses {
  CardId: string;
  CardNumber: string;
  BonusesToExceed: number | null;
  CardType: DiscountType;
}

export interface LoyaltySetOrderExtra {
  Discount: number;
  Bonuses: number;
}

export interface LoyaltySetOrderResponseItem {
  ProductId: string | null;
  Price: number;
  Quantity: number;
  Paid: number;
  Extra: LoyaltySetOrderExtra;
}

export interface LoyaltySetOrderResponse {
  OrderId: string | null;
  TotalAmount: number;
  MaxBonusesToExceed: number;
  BonusesToExceed: number;
  BonusesToEarn: number;
  FinalAmount: number;
  DiscountAmount: number;
  Message: string | null;
  Items: LoyaltySetOrderResponseItem[] | null;
}

export interface LoyaltyModelRecordInfo {
  BonusesToExceed: number;
  BonusesToEarn: number;
  CardId: string | null;
  CardNumber: string | null;
  CardType: string | null;
}

export type PayWithBonusesRequest = WithActiveBranchId<{
  recordId: number;
  data: LoyaltyModelPayWithBonuses;
}>;

export type ApplyReturnAsyncRequest = WithActiveBranchId<{
  recordId: number;
}>;

export type GetRecordInfoAsyncRequest = WithActiveBranchId<{
  recordId: number;
}>;

export type PayWithBonusesResponse = LoyaltySetOrderResponse;
export type ApplyReturnAsyncResponse = void;
export type GetRecordInfoAsyncResponse = LoyaltyModelRecordInfo;
